import React, { useMemo } from 'react'

import { array, arrayOf, shape, string, bool } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import ActionsBar from 'Pods/UnifiedNavigation/Shared/ActionsBar/ActionsBar'
import BudgetSection from 'Pods/UnifiedNavigation/Shared/BudgetSection/BudgetSection'
import CategoriesSection from 'Pods/UnifiedNavigation/Shared/CategoriesSection/CategoriesSection'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import TypeSection from './Components/TypeSection/TypeSection'

function Assets3DCategories({
  id = undefined,
  assetCategories,
  byType,
  locale = 'en',
  budgets = EMPTY_ARRAY,
  baseUrl,
  actionsConfig,
}) {
  const categoriesLength = assetCategories.length
  const column1 = assetCategories.slice(0, Math.ceil(categoriesLength / 2))
  const column2 = assetCategories.slice(Math.ceil(categoriesLength / 2), categoriesLength)

  const translations = useMemo(() => {
    const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

    return {
      categoriesSectionTitle: t('navigation.navbar.3d_models.categories'),
      typeSectionTitle: t('navigation.navbar.3d_models.types'),
      budgetSectionTitle: t('navigation.navbar.3d_models.budget'),
      budgetLabels: {
        below10: t('navigation.navbar.budgets.below_10'),
        moreThan50: t('navigation.navbar.budgets.more_than_50'),
        free: t('navigation.navbar.budgets.free'),
        sale: t('navigation.navbar.budgets.sale'),
      },
      actionsBar: {
        new: t('navigation.navbar.actions.new'),
        trending: t('navigation.navbar.actions.trending'),
        topSelling: t('navigation.navbar.actions.top_selling'),
        allModels: t('navigation.navbar.3d_models.all_models'),
      },
    }
  }, [locale])

  return (
    <div className="assets-3d-categories-dropdown" id={id}>
      <div className="assets-3d-categories">
        <CategoriesSection
          title={translations.categoriesSectionTitle}
          byCategory={{
            column1: [...(column1 || [])],
            column2: [...(column2 || [])],
          }}
        />
        <TypeSection byType={byType} title={translations.typeSectionTitle} />
        <BudgetSection
          budgets={budgets}
          baseUrl={baseUrl}
          modelType="cg"
          title={translations.budgetSectionTitle}
          actionsConfig={actionsConfig}
        />
        <ActionsBar
          baseUrl={baseUrl}
          translations={translations.actionsBar}
        />
      </div>
    </div>
  )
}

Assets3DCategories.propTypes = {
  id: string,
  assetCategories: array.isRequired,
  byType: arrayOf(shape({
    icon: string,
    name: string,
    path: string,
  })).isRequired,
  locale: string,
  budgets: arrayOf(shape({
    title: string.isRequired,
    path: string.isRequired,
    icon: string.isRequired,
    withSub: bool,
  })),
  baseUrl: string.isRequired,
  actionsConfig: shape({
    subscriptionMenuEnabled: bool,
    isActiveSubscriber: bool,
  }).isRequired,
}

export default Assets3DCategories
